(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6535],{

/***/ 73650:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(72269);

var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useAccordion = useAccordion;
exports.Accordion = Accordion;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3928));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(59415));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(39561));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(3498));

var _react = _interopRequireWildcard(__webpack_require__(34885));

var _Box = _interopRequireDefault(__webpack_require__(40300));

var __jsx = _react["default"].createElement;

function useAccordion() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var sections = props.sections,
      _props$oneAtATime = props.oneAtATime,
      oneAtATime = _props$oneAtATime === void 0 ? false : _props$oneAtATime; // Hook uncontrolled right now

  var _useState = (0, _react.useState)(sections.map(function (s) {
    return s.isOpenAtInit || false;
  })),
      isOpen = _useState[0],
      setOpen = _useState[1];

  var newSections = sections.map(function (section, index) {
    var open = function open() {
      var newIsOpen = (0, _toConsumableArray2["default"])(isOpen); //
      // if (oneAtATime) {
      //     newIsOpen = new Array(sections.length).fill(false);
      // }

      newIsOpen[index] = true;
      setOpen(newIsOpen);
    };

    var close = function close() {
      var newIsOpen = (0, _toConsumableArray2["default"])(isOpen);
      newIsOpen[index] = false;
      setOpen(newIsOpen);
    };

    var toggle = function toggle() {
      if (isOpen[index]) {
        close();
      } else {
        open();
      }
    };

    return {
      open: open,
      close: close,
      toggle: toggle,
      buttonProps: {
        onClick: function (_onClick) {
          function onClick() {
            return _onClick.apply(this, arguments);
          }

          onClick.toString = function () {
            return _onClick.toString();
          };

          return onClick;
        }(function () {
          toggle();

          if (sections.onClick) {
            onClick.apply(void 0, arguments);
          }
        }),
        selected: isOpen[index]
      },
      showHideProps: {
        isOpen: isOpen[index]
      }
    };
  });
  return {
    sections: newSections
  };
}

function AccordionSection(props) {}

function Accordion(props) {
  var children = props.children,
      controller = props.controller,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["children", "controller"]);
  children = _react["default"].Children.toArray(children);
  var sections = [];
  children.forEach(function (child, index) {
    if (child.type === AccordionSection) {
      var grandChildren = _react["default"].Children.toArray(child.props.children);

      var _child$props = child.props,
          isOpenAtInit = _child$props.isOpenAtInit,
          _restProps = (0, _objectWithoutProperties2["default"])(_child$props, ["isOpenAtInit"]);

      sections.push({
        button: grandChildren[0],
        showHide: grandChildren[1],
        headerAs: child.props.headerAs || "h6",
        isOpenAtInit: isOpenAtInit,
        props: _restProps
      });
    }
  });

  if (!controller) {
    controller = useAccordion((0, _objectSpread2["default"])({
      sections: sections.map(function (section) {
        return {
          isOpenAtInit: section.isOpenAtInit
        };
      })
    }, props));
  }

  var i = 0;
  return __jsx(_Box["default"], restProps, children.map(function (child, index) {
    if (child.type === AccordionSection) {
      var section = sections[i];
      var sectionController = controller.sections[i];
      i++;
      return __jsx(_Box["default"], (0, _extends2["default"])({}, section.props, {
        key: child.key || index
      }), __jsx(_Box["default"], {
        as: section.headerAs
      }, _react["default"].cloneElement(section.button, sectionController.buttonProps)), _react["default"].cloneElement(section.showHide, sectionController.showHideProps));
    }

    return child;
  }));
}

Accordion.Section = AccordionSection;
var _default = Accordion;
exports["default"] = _default;

/***/ }),

/***/ 49600:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(77848)


/***/ }),

/***/ 25400:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _prismicConfiguration = __webpack_require__(51427);
var _faq = _interopRequireDefault(__webpack_require__(30765));
var _infoPageMenu = _interopRequireDefault(__webpack_require__(34905));
var _infoPage = _interopRequireDefault(__webpack_require__(68635));
var _cache = __webpack_require__(75800);
var _prismicHelper = __webpack_require__(63981);
var _prismicErrorHandle = _interopRequireDefault(__webpack_require__(38115));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var fetcher = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(uid, language) {
    var _yield$getLanguage, cacheFileExist, cachedRequest, lang, cacheFilePath, _response$data$faq, _response$data$menu, response, faq, menu, mappedPage, mappedFaq, mappedMenu, _yield$getLanguage2, _cacheFileExist, _cachedRequest;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _prismicHelper.getLanguage)({
              language: language,
              filename: uid
            });
          case 2:
            _yield$getLanguage = _context.sent;
            cacheFileExist = _yield$getLanguage.cacheFileExist;
            cachedRequest = _yield$getLanguage.cachedRequest;
            lang = _yield$getLanguage.lang;
            cacheFilePath = _yield$getLanguage.cacheFilePath;
            if (!cacheFileExist) {
              _context.next = 9;
              break;
            }
            return _context.abrupt("return", cachedRequest);
          case 9:
            _context.prev = 9;
            _context.next = 12;
            return (0, _prismicHelper.getResponsePrismicByUID)({
              type: "infopage",
              uid: uid,
              lang: lang
            });
          case 12:
            response = _context.sent;
            if (response) {
              _context.next = 15;
              break;
            }
            return _context.abrupt("return", false);
          case 15:
            if (!((_response$data$faq = response.data.faq) !== null && _response$data$faq !== void 0 && _response$data$faq.id)) {
              _context.next = 21;
              break;
            }
            _context.next = 18;
            return (0, _prismicConfiguration.Client)().getByID(response.data.faq.id);
          case 18:
            _context.t0 = _context.sent;
            _context.next = 22;
            break;
          case 21:
            _context.t0 = false;
          case 22:
            faq = _context.t0;
            if (!((_response$data$menu = response.data.menu) !== null && _response$data$menu !== void 0 && _response$data$menu.id)) {
              _context.next = 29;
              break;
            }
            _context.next = 26;
            return (0, _prismicConfiguration.Client)().getByID(response.data.menu.id);
          case 26:
            _context.t1 = _context.sent;
            _context.next = 30;
            break;
          case 29:
            _context.t1 = false;
          case 30:
            menu = _context.t1;
            mappedPage = (0, _infoPage["default"])(response);
            mappedFaq = (0, _faq["default"])(faq);
            mappedMenu = (0, _infoPageMenu["default"])(menu);
            _context.next = 36;
            return (0, _cache.saveCacheFile)({
              cacheFilePath: cacheFilePath,
              filenameCategoryCache: "".concat(uid, ".json"),
              result: _objectSpread(_objectSpread({}, mappedPage), {}, {
                faq: mappedFaq === null || mappedFaq === void 0 ? void 0 : mappedFaq.content,
                menu: mappedMenu === null || mappedMenu === void 0 ? void 0 : mappedMenu.content
              })
            });
          case 36:
            return _context.abrupt("return", _objectSpread(_objectSpread({}, mappedPage), {}, {
              faq: mappedFaq === null || mappedFaq === void 0 ? void 0 : mappedFaq.content,
              menu: mappedMenu === null || mappedMenu === void 0 ? void 0 : mappedMenu.content
            }));
          case 39:
            _context.prev = 39;
            _context.t2 = _context["catch"](9);
            _context.next = 43;
            return (0, _prismicHelper.getLanguage)({
              language: language,
              filename: uid
            });
          case 43:
            _yield$getLanguage2 = _context.sent;
            _cacheFileExist = _yield$getLanguage2.cacheFileExist;
            _cachedRequest = _yield$getLanguage2.cachedRequest;
            if (!_cacheFileExist) {
              _context.next = 48;
              break;
            }
            return _context.abrupt("return", _cachedRequest);
          case 48:
            return _context.abrupt("return", (0, _prismicErrorHandle["default"])(_context.t2, "Prismic - info page"));
          case 49:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[9, 39]]);
  }));
  return function fetcher(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var _default = fetcher;
exports["default"] = _default;

/***/ }),

/***/ 70411:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
Object.defineProperty(exports, "if", ({
  enumerable: true,
  get: function get() {
    return _usePrismicInfoPage["default"];
  }
}));
Object.defineProperty(exports, "_i", ({
  enumerable: true,
  get: function get() {
    return _fetcher["default"];
  }
}));
var _usePrismicInfoPage = _interopRequireDefault(__webpack_require__(33891));
var _fetcher = _interopRequireDefault(__webpack_require__(25400));

/***/ }),

/***/ 33891:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _fetcher = _interopRequireDefault(__webpack_require__(25400));
var _swr = _interopRequireDefault(__webpack_require__(56157));
var usePrismicInfoPage = function usePrismicInfoPage(uid, language, fetchedPrismicContent) {
  return (0, _swr["default"])([uid, language, "usePrismicInfoPage"], _fetcher["default"], {
    initialData: fetchedPrismicContent
  });
};
var _default = usePrismicInfoPage;
exports["default"] = _default;

/***/ }),

/***/ 4080:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _Accordion = _interopRequireDefault(__webpack_require__(73650));
var _ShowHide = _interopRequireDefault(__webpack_require__(2500));
var _Button = _interopRequireDefault(__webpack_require__(96088));
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var PlusIcon = function PlusIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 13.438h-13v-1.2h13v1.2z"
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4 19.338v-13h1.2v13h-1.2z"
  }));
};
PlusIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var MinusIcon = function MinusIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 13.438h-13v-1.2h13v1.2z"
  }));
};
MinusIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var PlusIconLarge = function PlusIconLarge(props) {
  return __jsx("svg", props, __jsx("path", {
    d: "M18.224 9.14v18.283m-9.083-9.484h18.281",
    stroke: "#000",
    strokeWidth: "1.523"
  }));
};
PlusIconLarge.defaultProps = {
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var MinusIconLarge = function MinusIconLarge(props) {
  return __jsx("svg", props, __jsx("path", {
    d: "M9.14 18.282h18.282",
    stroke: "#000",
    strokeWidth: "1.523"
  }));
};
MinusIconLarge.defaultProps = {
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var defaultProps = {
  initialOpen: false,
  isLastElement: false,
  buttonPadding: {
    pt: 17,
    pb: 13
  },
  largerIcons: false
};
var FaqRaw = function FaqRaw(props) {
  var question = props.question,
    answer = props.answer,
    _props$initialOpen = props.initialOpen,
    initialOpen = _props$initialOpen === void 0 ? defaultProps.initialOpen : _props$initialOpen,
    labelFont = props.labelFont,
    textFont = props.textFont,
    _props$isLastElement = props.isLastElement,
    isLastElement = _props$isLastElement === void 0 ? defaultProps.isLastElement : _props$isLastElement,
    _props$buttonPadding = props.buttonPadding,
    buttonPadding = _props$buttonPadding === void 0 ? defaultProps.buttonPadding : _props$buttonPadding,
    _props$largerIcons = props.largerIcons,
    largerIcons = _props$largerIcons === void 0 ? defaultProps.largerIcons : _props$largerIcons;
  var plusIcon = largerIcons ? __jsx(PlusIconLarge, null) : __jsx(PlusIcon, null);
  var minusIcon = largerIcons ? __jsx(MinusIconLarge, null) : __jsx(MinusIcon, null);
  return __jsx(_Accordion["default"], {
    sx: {
      minWidth: "100%"
    }
  }, __jsx(_Accordion["default"].Section, {
    isOpenAtInit: initialOpen
  }, __jsx(_Button["default"], {
    sx: _objectSpread(_objectSpread({
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center"
    }, buttonPadding), {}, {
      width: "100%",
      color: "main",
      ":focus": {
        outline: 0,
        boxShadow: "none"
      },
      "::-moz-focus-inner": {
        border: 0
      }
    })
  }, function (_ref) {
    var selected = _ref.selected;
    return __jsx(_react["default"].Fragment, null, __jsx(_Box["default"], {
      sx: {
        font: labelFont ? labelFont : "base_sans_bold",
        maxWidth: "calc(100% - 24px)"
      }
    }, question), __jsx(_Box["default"], null, selected ? minusIcon : plusIcon));
  }), __jsx(_ShowHide["default"], null, __jsx(_Box["default"], {
    sx: {
      p: "16px 0px",
      pt: 0,
      font: textFont ? textFont : "body",
      color: "main"
    }
  }, answer.map(function (answerParagraph, index) {
    return __jsx(_Box["default"], {
      key: "answerParagraph-".concat(index),
      dangerouslySetInnerHTML: {
        __html: answerParagraph.text
      }
    });
  })))), !isLastElement && __jsx(_Box["default"], {
    sx: {
      height: "1px",
      bg: "neutral"
    }
  }));
};
var _default = FaqRaw;
exports.Z = _default;

/***/ }),

/***/ 36880:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Op = exports.ZP = void 0;
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _head = _interopRequireDefault(__webpack_require__(49600));
var _router = __webpack_require__(53746);
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _LanguageProvider = __webpack_require__(8989);
var _useSalesmanago = _interopRequireDefault(__webpack_require__(54569));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var META_TYPE = {
  searchResults: "product-search",
  productPage: "product-page",
  categoryPage: "category-page, product-list"
};
exports.Op = META_TYPE;
Object.freeze(META_TYPE);
var defaultProps = {
  siteName: "Dajar"
};
var MetaTags = function MetaTags(props) {
  var page = props.page,
    sku = props.sku,
    passedUrl = props.url,
    productRegularPrice = props.productRegularPrice,
    productSpecialPrice = props.productSpecialPrice,
    productAvailability = props.productAvailability,
    productBrand = props.productBrand,
    productCategory = props.productCategory,
    currentPageNumber = props.currentPageNumber,
    tags = props.tags,
    noFollow = props.noFollow,
    domains = props.domains,
    _props$siteName = props.siteName,
    siteName = _props$siteName === void 0 ? defaultProps.siteName : _props$siteName;
  var translations = {
    page: (0, _langLibrary["default"])("page")
  };
  var singleDomain = props.singleDomain,
    title = props.title,
    description = props.description,
    imageUrl = props.imageUrl;
  var handleSalesmanagoEvent = (0, _useSalesmanago["default"])();
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  singleDomain = singleDomain ? "https://".concat(singleDomain) : null;
  var baseUrl = domains ? "https://".concat(Object.keys(domains).find(function (domain) {
    return domains[domain] === language.language;
  })) : singleDomain;
  var router = (0, _router.useRouter)();
  var routePaths = router !== null && router !== void 0 && router.asPath ? router.asPath.split("?") : [];
  var defaultOgImage = "/static/images/dajar-og-image.jpg";
  if (currentPageNumber) {
    title += "| ".concat(translations.page, " ").concat(currentPageNumber);
  }
  var tagsPrefix = tags && tags.length > 3 ? tags.join(", ") + "... - " : tags && tags.length > 0 ? tags.join(", ") + " - " : "";
  title = tagsPrefix + title;
  description = tagsPrefix + description;
  var url = noFollow ? baseUrl + passedUrl : baseUrl + "".concat(routePaths[0]);
  imageUrl = imageUrl === undefined || page === META_TYPE.searchResults ? baseUrl + defaultOgImage : baseUrl + imageUrl;
  (0, _react.useEffect)(function () {
    handleSalesmanagoEvent("VISIT");
  }, [title]);
  if (title !== "undefined") {
    return __jsx(_head["default"], null, __jsx("title", null, title), __jsx("meta", {
      name: "viewport",
      content: "width=device-width, initial-scale=1.0"
    }), __jsx("meta", {
      name: "robots",
      content: page === META_TYPE.searchResults || noFollow ? "noindex, nofollow" : "index, follow"
    }), __jsx("link", {
      rel: "canonical",
      href: url
    }), __jsx("meta", {
      name: "title",
      content: title
    }), __jsx("meta", {
      name: "description",
      content: description
    }), __jsx("meta", {
      property: "og:site_name",
      content: siteName
    }), __jsx("meta", {
      property: "og:locale",
      content: language === null || language === void 0 ? void 0 : language.language
    }), __jsx("meta", {
      property: "og:title",
      content: title
    }), __jsx("meta", {
      property: "og:description",
      content: description
    }), __jsx("meta", {
      property: "og:type",
      content: page === META_TYPE.productPage ? "product" : "website"
    }), __jsx("meta", {
      property: "og:url",
      content: url
    }), __jsx("meta", {
      property: "og:image",
      content: imageUrl
    }), __jsx("meta", {
      property: "og:image:alt",
      content: title
    }), page === META_TYPE.productPage && __jsx(_react["default"].Fragment, null, __jsx("meta", {
      property: "product:condition",
      content: "new"
    }), __jsx("meta", {
      property: "product:availability",
      content: productAvailability
    }), __jsx("meta", {
      property: "product:original_price:amount",
      content: productRegularPrice
    }), __jsx("meta", {
      property: "product:original_price:currency",
      content: "PLN"
    }), __jsx("meta", {
      property: "product:price:amount",
      content: productSpecialPrice
    }), __jsx("meta", {
      property: "product:price:currency",
      content: "PLN"
    }), __jsx("meta", {
      property: "product:retailer_item_id",
      content: sku
    }), __jsx("meta", {
      property: "product:brand",
      content: productBrand
    }), __jsx("meta", {
      property: "product:category",
      content: productCategory
    })), __jsx("meta", {
      property: "twitter:card",
      content: page === META_TYPE.productPage ? "product" : "summary_large_image"
    }), __jsx("meta", {
      property: "twitter:site",
      content: "@DAJARpl"
    }), __jsx("meta", {
      property: "twitter:url",
      content: url
    }), __jsx("meta", {
      property: "twitter:title",
      content: title
    }), __jsx("meta", {
      property: "twitter:description",
      content: description.slice(0, 100)
    }), __jsx("meta", {
      property: "twitter:image",
      content: imageUrl
    }));
  } else {
    return __jsx(_head["default"], null);
  }
};
var _default = MetaTags;
exports.ZP = _default;

/***/ }),

/***/ 95718:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _Display = _interopRequireDefault(__webpack_require__(35572));
var _Accordion = _interopRequireDefault(__webpack_require__(73650));
var _ButtonRaw = _interopRequireDefault(__webpack_require__(30650));
var _ShowHide = _interopRequireDefault(__webpack_require__(2500));
var _router = __webpack_require__(53746);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ChevronDownIcon = function ChevronDownIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.923 10.263l.848-.849 5.576 5.576 5.576-5.576.848.849-6.424 6.424-6.424-6.424z"
  }));
};
ChevronDownIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var ChevronUpIcon = function ChevronUpIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.35 8.07l6.42 6.42-.85.85-5.57-5.58-5.58 5.58-.85-.85z"
  }));
};
ChevronUpIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var defaultProps = {
  resetPosition: false,
  button: __jsx(_ButtonRaw["default"], null),
  rowStyle: {
    px: "20px",
    py: "s7",
    font: "s_sans",
    borderWidth: "1px",
    borderStyle: "solid",
    borderBottomColor: "neutral",
    borderTopColor: "transparent",
    borderLeftColor: "transparent",
    borderRightColor: "transparent",
    boxSizing: "border-box",
    color: "main",
    width: "100%",
    ":focus": {
      outline: 0,
      boxShadow: "none"
    },
    "::-moz-focus-inner": {
      border: 0
    }
  },
  additionalActiveRowStyles: {
    font: "s_sans_bold",
    borderWidth: "1px",
    borderColor: "main"
  }
};
var SideStickyMenu = function SideStickyMenu(_ref) {
  var _menuData$find$label, _menuData$find;
  var menuData = _ref.menuData,
    initialActiveRow = _ref.initialActiveRow,
    _onClick = _ref.onClick,
    _ref$resetPosition = _ref.resetPosition,
    resetPosition = _ref$resetPosition === void 0 ? defaultProps.resetPosition : _ref$resetPosition,
    _ref$button = _ref.button,
    button = _ref$button === void 0 ? defaultProps.button : _ref$button,
    _ref$rowStyle = _ref.rowStyle,
    rowStyle = _ref$rowStyle === void 0 ? defaultProps.rowStyle : _ref$rowStyle,
    _ref$additionalActive = _ref.additionalActiveRowStyles,
    additionalActiveRowStyles = _ref$additionalActive === void 0 ? defaultProps.additionalActiveRowStyles : _ref$additionalActive;
  var router = (0, _router.useRouter)();
  var _useState = (0, _react.useState)(initialActiveRow),
    activeRow = _useState[0],
    setActiveRow = _useState[1];
  var _useState2 = (0, _react.useState)(false),
    accordionOpen = _useState2[0],
    setAccordionOpen = _useState2[1];
  var activeStyle = _objectSpread(_objectSpread({}, rowStyle), additionalActiveRowStyles);
  var buttonStyle = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  };
  var onMenuClick = function onMenuClick(url, urlType) {
    if (urlType === "local") {
      router.push("/info/" + url);
    } else {
      window.open(url, "_blank");
    }
  };
  var mobileMenuOptions = menuData === null || menuData === void 0 ? void 0 : menuData.map(function (menuRaw, index) {
    return menuRaw.url !== activeRow && /*#__PURE__*/_react["default"].cloneElement(button, {
      sx: rowStyle,
      id: menuRaw.url,
      onClick: function onClick(e) {
        _onClick ? _onClick(e) : onMenuClick(menuRaw.url, menuRaw.url_type);
        setActiveRow(menuRaw.url);
        setAccordionOpen(false);
      },
      key: index
    }, menuRaw.label);
  });
  return __jsx(_Box["default"], {
    sx: !resetPosition && {
      position: ["relative", null, "sticky", null],
      top: [0, null, "30vh", null],
      width: ["calc(100% + 10vw)", null, "318px", null],
      left: "-5vw"
    }
  }, __jsx(_Display["default"], {
    when: [true, null, false]
  }, __jsx(_Accordion["default"], null, __jsx(_Accordion["default"].Section, {
    isOpenAtInit: true
  }, /*#__PURE__*/_react["default"].cloneElement(button, {
    sx: {
      width: "100%",
      ":focus": {
        outline: 0,
        boxShadow: "none"
      },
      "::-moz-focus-inner": {
        border: 0
      }
    }
  }, __jsx(_Box["default"], {
    onClick: function onClick() {
      setAccordionOpen(!accordionOpen);
    },
    sx: accordionOpen ? _objectSpread(_objectSpread({}, buttonStyle), activeStyle) : _objectSpread(_objectSpread({}, buttonStyle), rowStyle)
  }, __jsx(_Box["default"], {
    sx: {
      font: "s_sans_bold"
    }
  }, (_menuData$find$label = menuData === null || menuData === void 0 ? void 0 : (_menuData$find = menuData.find(function (option) {
    if (option.url === activeRow) {
      return option;
    }
  })) === null || _menuData$find === void 0 ? void 0 : _menuData$find.label) !== null && _menuData$find$label !== void 0 ? _menuData$find$label : ""), __jsx(_Box["default"], null, accordionOpen ? __jsx(ChevronUpIcon, null) : __jsx(ChevronDownIcon, null)))), resetPosition ? __jsx(_Box["default"], {
    sx: {
      display: accordionOpen ? "block" : "none"
    }
  }, mobileMenuOptions) : __jsx(_ShowHide["default"], null, mobileMenuOptions)))), __jsx(_Display["default"], {
    when: [false, null, true]
  }, menuData.map(function (menuRaw, index) {
    return /*#__PURE__*/_react["default"].cloneElement(button, {
      sx: activeRow === menuRaw.url ? activeStyle : rowStyle,
      id: menuRaw.url,
      key: index,
      onClick: function onClick(e) {
        setActiveRow(menuRaw.url);
        if (_onClick) {
          _onClick(e);
        } else {
          setAccordionOpen(false);
          onMenuClick(menuRaw.url, menuRaw.url_type);
        }
      }
    }, menuRaw.label);
  })));
};
var _default = SideStickyMenu;
exports["default"] = _default;

/***/ }),

/***/ 30765:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var mapFaq = function mapFaq(response) {
  if (!response) return false;
  return {
    content: response.data.body.map(function (question) {
      return {
        question: question.items && question.items[0].question[0].text,
        answer: question.items && question.items[0].answer
      };
    })
  };
};
var _default = mapFaq;
exports["default"] = _default;

/***/ }),

/***/ 68635:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _image = __webpack_require__(43733);
var mapInfoPage = function mapInfoPage(response) {
  var _response$data$seotit, _response$data$seodes;
  if (!response) return false;
  return {
    title: response.data.title[0].text,
    seoTitle: ((_response$data$seotit = response.data.seotitle) === null || _response$data$seotit === void 0 ? void 0 : _response$data$seotit.length) > 0 ? response.data.seotitle[0].text : false,
    seoDescription: ((_response$data$seodes = response.data.seodescription) === null || _response$data$seodes === void 0 ? void 0 : _response$data$seodes.length) > 0 ? response.data.seodescription[0].text : false,
    content: response.data.body.map(function (paragraph) {
      return {
        text: paragraph.primary.text
      };
    }),
    option: response.data.body.map(function (paragraph) {
      if (paragraph.slice_type === "option") {
        return paragraph.items[0];
      }
    }),
    image: response.data.body.map(function (paragraph) {
      if (paragraph.slice_type === "image") {
        if (paragraph.primary) {
          return response.type === "pro-infopage" ? (0, _image.mapRichImage)(paragraph.primary).image : paragraph.primary;
        }
      }
    })
  };
};
var _default = mapInfoPage;
exports["default"] = _default;

/***/ }),

/***/ 34905:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var mapInfoPageMenu = function mapInfoPageMenu(response) {
  if (!response) return false;
  return {
    content: response.data.body.map(function (option) {
      return {
        label: option.items && option.items[0].title[0].text,
        url: option.items && option.items[0].url_type === "local" ? option.items[0].url.url.replace("https://", "") : option.items[0].url.url,
        url_type: option.items && option.items[0].url_type
      };
    })
  };
};
var _default = mapInfoPageMenu;
exports["default"] = _default;

/***/ }),

/***/ 4861:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/[info]",
      function () {
        return __webpack_require__(83192);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 39125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_MetaTags; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(88349);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(34885);
// EXTERNAL MODULE: ../components-new/dist/MetaTags/index.js
var MetaTags = __webpack_require__(36880);
;// CONCATENATED MODULE: ./conf/lang.domains.json
var lang_domains_namespaceObject = JSON.parse('{"dajar.cz":"cz","dajar.de":"de","dajar.es":"es","dajar.fr":"fr","dajar.pl":"pl","dajar.it":"it","dajar.co.uk":"gb","dajar.ro":"ro","dajar.se":"se","dajar.sk":"sk"}');
;// CONCATENATED MODULE: ./src/components/MetaTags/index.js




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var MetaTags_MetaTags = function(props) {
    var propsExt = _objectSpread({}, props, {
        domains: lang_domains_namespaceObject
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTags/* default */.ZP, _objectSpread({}, propsExt)));
};
/* harmony default export */ var components_MetaTags = (MetaTags_MetaTags);


/***/ }),

/***/ 83192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _info_; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94986);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(88349);
// EXTERNAL MODULE: ./src/globals.js
var globals = __webpack_require__(88084);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(34885);
// EXTERNAL MODULE: ../helpers/dist/langLibrary/index.js
var langLibrary = __webpack_require__(51493);
// EXTERNAL MODULE: ../../node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(56410);
// EXTERNAL MODULE: ../../node_modules/@commerce-ui/core2/Box/index.js
var Box = __webpack_require__(40300);
var Box_default = /*#__PURE__*/__webpack_require__.n(Box);
// EXTERNAL MODULE: ../../node_modules/@commerce-ui/core2/Grid/index.js
var Grid = __webpack_require__(98290);
var Grid_default = /*#__PURE__*/__webpack_require__.n(Grid);
// EXTERNAL MODULE: ../../node_modules/@commerce-ui/core2/Container/index.js
var Container = __webpack_require__(58709);
var Container_default = /*#__PURE__*/__webpack_require__.n(Container);
// EXTERNAL MODULE: ./src/containers/UI/PageContainer/index.js + 2 modules
var PageContainer = __webpack_require__(73764);
// EXTERNAL MODULE: ../components-new/dist/SideStickyMenu/index.js
var SideStickyMenu = __webpack_require__(95718);
;// CONCATENATED MODULE: ./src/components/SideStickyMenu/index.js



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var SideStickyMenu_SideStickyMenu = function(props) {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(SideStickyMenu["default"], _objectSpread({}, props));
};
/* harmony default export */ var components_SideStickyMenu = (SideStickyMenu_SideStickyMenu);

// EXTERNAL MODULE: ../components-new/dist/FaqRaw/index.js
var FaqRaw = __webpack_require__(4080);
;// CONCATENATED MODULE: ./src/components/FaqRaw/index.js



function FaqRaw_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function FaqRaw_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            FaqRaw_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var FaqRaw_FaqRaw = function(props) {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(FaqRaw/* default */.Z, FaqRaw_objectSpread({}, props));
};
/* harmony default export */ var components_FaqRaw = (FaqRaw_FaqRaw);

// EXTERNAL MODULE: ./src/components/MetaTags/index.js + 1 modules
var MetaTags = __webpack_require__(39125);
// EXTERNAL MODULE: ../API/dist/hooks/prismic/usePrismicInfoPage/index.js
var usePrismicInfoPage = __webpack_require__(70411);
;// CONCATENATED MODULE: ./src/pages/info/[info].js














function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var InfoPage = function(props) {
    var ref;
    var initialPrismicResponse = props.initialPrismicResponse, initialUid = props.initialUid, lang = props.lang;
    var translations = {
        seoDescription: (0,langLibrary["default"])("Default seo description"),
        seoTitle: (0,langLibrary["default"])("Default seo title")
    };
    var ref1 = (0,usePrismicInfoPage/* usePrismicInfoPage */["if"])(initialUid, lang, initialPrismicResponse), prismicResponse = ref1.data;
    var faq = (prismicResponse === null || prismicResponse === void 0 ? void 0 : prismicResponse.faq) && /*#__PURE__*/ (0,jsx_runtime.jsxs)((Box_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                sx: {
                    height: "1px",
                    bg: "neutral"
                }
            }),
            prismicResponse.faq.map(function(question, index) {
                return question && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FaqRaw, {
                    question: question.question,
                    answer: question.answer
                }, "faqRaw-".concat(index));
            })
        ]
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTags/* default */.Z, {
                description: (prismicResponse === null || prismicResponse === void 0 ? void 0 : prismicResponse.seoDescription) ? prismicResponse.seoDescription : translations.seoDescription,
                title: (prismicResponse === null || prismicResponse === void 0 ? void 0 : prismicResponse.seoTitle) ? prismicResponse.seoTitle : translations.seoTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageContainer/* default */.Z, {
                footerContent: props.footerContent,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Container_default()), {
                    sx: {
                        mt: [
                            0,
                            null,
                            "s6",
                            null
                        ]
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((Grid_default()), {
                        cols: [
                            24,
                            null,
                            20,
                            null
                        ],
                        children: [
                            (prismicResponse === null || prismicResponse === void 0 ? void 0 : prismicResponse.content) && /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                                sx: {
                                    gridColumn: [
                                        "1 / span 24",
                                        null,
                                        "1 / span 10",
                                        null
                                    ],
                                    order: [
                                        2,
                                        null,
                                        1,
                                        null
                                    ]
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                                    sx: {
                                        color: "main",
                                        font: "base",
                                        img: {
                                            width: "100%"
                                        },
                                        a: {
                                            color: "main",
                                            textDecoration: "none"
                                        },
                                        h1: {
                                            font: "xl",
                                            m: 0
                                        }
                                    },
                                    children: (prismicResponse === null || prismicResponse === void 0 ? void 0 : prismicResponse.content) && prismicResponse.content.map(function(paragraph, index) {
                                        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)((Box_default()), {
                                            children: [
                                                index === 1 && faq,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                                                    sx: {
                                                        my: "s10"
                                                    },
                                                    children: prismic_reactjs.RichText.render(paragraph.text)
                                                }, "paragraphText-".concat(index))
                                            ]
                                        }, "paragraph-".concat(index)));
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                                sx: {
                                    gridColumn: [
                                        "1 / span 24",
                                        null,
                                        "11 / span 10",
                                        null
                                    ],
                                    order: [
                                        1,
                                        null,
                                        2,
                                        null
                                    ],
                                    pl: [
                                        0,
                                        null,
                                        "10%",
                                        "20%"
                                    ]
                                },
                                children: (prismicResponse === null || prismicResponse === void 0 ? void 0 : (ref = prismicResponse.menu) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SideStickyMenu, {
                                    menuData: prismicResponse.menu,
                                    initialActiveRow: initialUid
                                })
                            })
                        ]
                    })
                })
            })
        ]
    }));
};
InfoPage.getInitialProps = (function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(props) {
        var uid, response;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    uid = props.query.info;
                    _ctx.next = 4;
                    return (0,usePrismicInfoPage/* fetcher */._i)(uid, props.language);
                case 4:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", {
                        initialPrismicResponse: response,
                        initialUid: uid,
                        lang: props.language
                    });
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error(_ctx.t0);
                    return _ctx.abrupt("return", _ctx.t0);
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function(props) {
        return _ref.apply(this, arguments);
    };
})();
/* harmony default export */ var _info_ = (InfoPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(4861); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);